import React from 'react';

const Bar = ({ className = '' }) => <div className={`animate-pulse rounded-md bg-[#E2ECEA] ${className}`} />;

// Full-page placeholder: header + stat cards + list rows.
export const PageSkeleton = () => (
  <div className="p-4 sm:p-6 lg:p-8 space-y-6 w-full" data-testid="page-skeleton" aria-busy="true">
    <div className="space-y-2">
      <Bar className="h-3 w-24" />
      <Bar className="h-8 w-72" />
      <Bar className="h-3 w-96 max-w-full" />
    </div>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {[0, 1, 2, 3].map((i) => <Bar key={i} className="h-20" />)}
    </div>
    <div className="medical-card p-4 space-y-3">
      {[0, 1, 2, 3, 4, 5].map((i) => <Bar key={i} className="h-10" />)}
    </div>
  </div>
);

export const TableRowsSkeleton = ({ cols = 6, rows = 5 }) => (
  <>
    {Array.from({ length: rows }).map((_, r) => (
      <tr key={r} data-testid="table-skeleton-row" aria-busy="true">
        {Array.from({ length: cols }).map((__, c) => (
          <td key={c} className="px-4 py-3"><Bar className={`h-4 ${c === 0 ? 'w-24' : 'w-full'}`} /></td>
        ))}
      </tr>
    ))}
  </>
);

export const InlineSkeleton = ({ lines = 3, className = '' }) => (
  <div className={`space-y-2 py-2 w-full ${className}`} data-testid="inline-skeleton" aria-busy="true">
    {Array.from({ length: lines }).map((_, i) => <Bar key={i} className={`h-4 ${i === lines - 1 ? 'w-2/3' : 'w-full'}`} />)}
  </div>
);
